<template>
  <SvgIcon icon="header.football" 
    :selected="selected" 
    className="mr-05rem"
    v-if="pathName === 'home'" />

  <SvgIcon icon="header.basketball" 
    :selected="selected" 
    className="mr-05rem"
    v-if="pathName === 'basketball'" />


  <!-- <svg v-if="pathName === 'news' && !selected" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6667 3.33333V12.6667H3.33333V3.33333H12.6667ZM13.4 2H2.6C2.26667 2 2 2.26667 2 2.6V13.4C2 13.6667 2.26667 14 2.6 14H13.4C13.6667 14 14 13.6667 14 13.4V2.6C14 2.26667 13.6667 2 13.4 2ZM7.33333 4.66667H11.3333V6H7.33333V4.66667ZM4.66667 7.33333H11.3333V8.66667H4.66667V7.33333ZM4.66667 10H11.3333V11.3333H4.66667V10ZM4.66667 4.66667H6V6H4.66667V4.66667Z" 
      :fill="iconColor"/>
  </svg>
  <svg v-else-if="pathName === 'news' && selected" class="selected" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.6 2H13.4C13.6667 2 14 2.26667 14 2.6V13.4C14 13.6667 13.6667 14 13.4 14H2.6C2.26667 14 2 13.6667 2 13.4V2.6C2 2.26667 2.26667 2 2.6 2ZM7.33333 4.66667H11.3333V6H7.33333V4.66667ZM4.66667 7.33333H11.3333V8.66667H4.66667V7.33333ZM11.3333 10H4.66667V11.3333H11.3333V10ZM4.66667 4.66667H6V6H4.66667V4.66667Z" 
      :fill="iconColor" />
  </svg>  -->

</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  props: {
    pathName: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "isMobile",
    ]),
    iconColor() {
      if(this.isMobile) {
        return '#000'
      } else {
        if(this.selected) {
          return '#FFF'
        }
        return '#000'
      }
    }
  },
};
</script>

<style scoped>
svg {
  margin-right: 0.5rem;
}
.selected rect,
.selected path {
  /* fill: #000000; */
}
@media(max-width: 768px) {  /* for test */
svg {
  margin-right: 0;
  margin-left: 0.25rem;
}
}
</style>
